import ElementInternal from "../../../interfaces/ElementInternal";

const Element = ({ hidden, render, ...restProps }: ElementInternal) => {
  if (hidden) return null;
  return render({
    ...restProps
  });
};

Element.defaultProps = {
  hidden: false
};

export default Element;
